<template>
  <div class="post-content-type">
    <div v-if="data && data.content && data.content.translations">
      <h5>
        Форма для заполнения: {{ data.content.title }}
        <span v-if="data.content.description"
          >({{ data.content.description }})</span
        >
      </h5>
      <img :src="image" />
      <!-- <p v-for="(album_title, key) in data.content.translations" :key="key">
             <span class="text-info"> {{album_title.locale}}:</span>   {{album_title.title}}
          </p> -->
      <div>
        <br /><button
          class="btn btn-sm btn-warning"
          @click="openObject(data.content.id)"
        >
          Посмотреть
        </button>
      </div>
    </div>
    <button
      class="btn btn-sm btn-danger item-delete"
      @click="$emit('remove', index)"
    >
      <i class="ti-trash"></i>
    </button>
  </div>
</template>

<script>
export default {
  methods: {
    openObject(id) {
      const element = `item_form`;
      let query = Object.assign({}, this.$route.query);
      if (query[element] == id) {
        return false;
      }
      if (query[element]) {
        delete query[element];
      }
      query[element] = id;
      setTimeout(() => {
        this.$router.replace({ query: query });
      }, 20);
    },
  },
  props: {
    index: {
      default: null,
    },
    data: {
      default: null,
    },
  },
  data: () => ({
    image: "",
  }),
};
</script>
